import * as React from "react";
import type { SVGProps } from "react";
const SvgEmptyData = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={107}
    fill="none"
    viewBox="0 0 66 107" {...props}
  >
    <path
      fill="#FFCE00"
      d="m28.742 43.03-4.24.233c-.959-.005-1.547.138-1.77.98q-.003.007-.009.012l-.745 5.202-.396-4.422c-.067-.744-.047-1.582-1.107-1.816q-.007-.003-.012-.009l-4.735-.444 3.863-.31c1.749-.199 2.052-.96 2.177-1.7q.02-.111.032-.225l.458-3.818.293 3.699c.059.741.369 1.657 1.041 1.856q.007.003.012.009l5.137.75z"
    />
    <path
      fill="#00217B"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M51.03 60.453s8.006-5.264 11.55 1.607c3.543 6.871-10.006 23.584-10.006 23.584l2.459-10.653s4.808-8.407 3.12-10.857-4.606.538-4.606.538z"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.928}
      d="M15.05 57.952c-3.743 2.212-5.874 6.35-6.227 10.683-.68 8.342.3 23.248 10.41 28.778 14.929 8.165 28.79-1.211 32.23-8.91 3.072-6.875 3.149-10.062 3.642-17.787.346-5.447-2.56-9.898-7.186-12.794-4.147-2.593-10.27-4.367-15.677-4.291-6.367.088-12.574 1.589-17.192 4.319z"
    />
    <path
      fill="url(#empty-data_svg__a)"
      d="M52.592 67.819c-.049 1.94-.986 3.743-2.597 5.297-1.977 1.911-4.971 3.443-8.58 4.393-1.005.265-2.06.485-3.152.652a36 36 0 0 1-6.393.396c-11.286-.288-20.307-5.562-20.15-11.779.16-6.216 9.435-11.021 20.721-10.734 7.641.195 14.246 2.676 17.66 6.182 1.634 1.677 2.54 3.586 2.488 5.594z"
      opacity={0.73}
    />
    <g
      style={{
        mixBlendMode: "multiply",
      }}
    >
      <path
        fill="#ABABAB"
        d="M31.859 3.162a.36.36 0 0 1 .315.061l-.001.001a9 9 0 0 1 1.953 1.946l.205.29a10.2 10.2 0 0 1 1.705 4.995l.018.379c.05 1.758-.4 3.455-1.251 4.985l-.189.325c-.598.99-1.317 1.886-2.05 2.757-.644.765-1.296 1.508-1.898 2.288l-.256.336c-.57.77-1.062 1.59-1.453 2.45 2.184-.32 4.411-.24 6.545.444l.375.128c1.883.664 3.792 1.802 4.842 3.594l.16.298c.696 1.405.67 3.064.128 4.49l-.125.302c-.657 1.485-1.837 2.766-3.327 3.433l-.303.125c-1.688.643-3.483.478-5.142-.274l-.33-.158c-1.751-.885-3.195-2.419-3.933-4.26v.002c-.75-1.868-.84-3.932-.438-5.886l.086-.389q.104-.429.235-.84c-2.25.501-4.431 1.424-6.443 2.555l-.666.385c-3.479 2.071-6.675 4.857-9.023 8.188l-.458.673c-1.171 1.788-2.1 3.806-2.549 5.834L8.512 43a12.95 12.95 0 0 0 .186 5.752l.102.36c1.096 3.704 3.763 6.813 6.884 9l.385.263c3.985 2.675 8.66 4.077 13.27 5.384l.005.001h.002v.002a.37.37 0 0 1 .237.204.41.41 0 0 1-.154.5.37.37 0 0 1-.228.059l-.085-.016c-.915-.26-1.83-.523-2.744-.8l-.91-.28c-4.417-1.388-8.868-3.212-12.366-6.393l-.336-.311c-2.909-2.77-5.054-6.49-5.248-10.612l-.012-.4c-.073-4.52 2.088-8.623 5.007-12.01l.556-.628c2.831-3.107 6.344-5.68 10.162-7.38l.719-.307a22.3 22.3 0 0 1 4.097-1.254c.61-1.496 1.503-2.826 2.595-4.152l1.136-1.344c1.138-1.34 2.237-2.69 2.894-4.303l.13-.344c1.23-3.465.056-7.628-2.777-9.902l-.288-.221c-.207-.15-.187-.394-.095-.538a.4.4 0 0 1 .223-.168m6.124 23.295c-1.569-1.043-3.42-1.636-5.296-1.819l-.375-.03a15.6 15.6 0 0 0-3.697.203 11 11 0 0 0-.597 2.474v.001l-.037.371c-.153 1.86.199 3.767 1.194 5.33l.192.288c1 1.415 2.503 2.486 4.17 2.92l.317.074c1.589.325 3.249.003 4.533-1.027l.231-.194c1.056-.938 1.804-2.264 1.98-3.664l.03-.302c.123-1.837-.903-3.362-2.35-4.42z"
      />
      <path
        stroke="#ABABAB"
        strokeWidth={0.4}
        d="M31.859 3.162a.36.36 0 0 1 .315.061l-.001.001a9 9 0 0 1 1.953 1.946l.205.29a10.2 10.2 0 0 1 1.705 4.995l.018.379c.05 1.758-.4 3.455-1.251 4.985l-.189.325c-.598.99-1.317 1.886-2.05 2.757-.644.765-1.296 1.508-1.898 2.288l-.256.336c-.57.77-1.062 1.59-1.453 2.45 2.184-.32 4.411-.24 6.545.444l.375.128c1.883.664 3.792 1.802 4.842 3.594l.16.298c.696 1.405.67 3.064.128 4.49l-.125.302c-.657 1.485-1.837 2.766-3.327 3.433l-.303.125c-1.688.643-3.483.478-5.142-.274l-.33-.158c-1.751-.885-3.195-2.419-3.933-4.26v.002c-.75-1.868-.84-3.932-.438-5.886l.086-.389q.104-.429.235-.84c-2.25.501-4.431 1.424-6.443 2.555l-.666.385c-3.479 2.071-6.675 4.857-9.023 8.188l-.458.673c-1.171 1.788-2.1 3.806-2.549 5.834L8.512 43a12.95 12.95 0 0 0 .186 5.752l.102.36c1.096 3.704 3.763 6.813 6.884 9l.385.263c3.985 2.675 8.66 4.077 13.27 5.384l.005.001h.002v.002a.37.37 0 0 1 .237.204.41.41 0 0 1-.154.5.37.37 0 0 1-.228.059l-.085-.016c-.915-.26-1.83-.523-2.744-.8l-.91-.28c-4.417-1.388-8.868-3.212-12.366-6.393l-.336-.311c-2.909-2.77-5.054-6.49-5.248-10.612l-.012-.4c-.073-4.52 2.088-8.623 5.007-12.01l.556-.628c2.831-3.107 6.344-5.68 10.162-7.38l.719-.307a22.3 22.3 0 0 1 4.097-1.254c.61-1.496 1.503-2.826 2.595-4.152l1.136-1.344c1.138-1.34 2.237-2.69 2.894-4.303l.13-.344c1.23-3.465.056-7.628-2.777-9.902l-.288-.221c-.207-.15-.187-.394-.095-.538a.4.4 0 0 1 .223-.168Zm6.124 23.295c-1.569-1.043-3.42-1.636-5.296-1.819l-.375-.03a15.6 15.6 0 0 0-3.697.203 11 11 0 0 0-.597 2.474v.001l-.037.371c-.153 1.86.199 3.767 1.194 5.33l.192.288c1 1.415 2.503 2.486 4.17 2.92l.317.074c1.589.325 3.249.003 4.533-1.027l.231-.194c1.056-.938 1.804-2.264 1.98-3.664l.03-.302c.123-1.837-.903-3.362-2.35-4.42z"
      />
    </g>
    <path
      fill="#FFCE00"
      d="M52.592 67.817c-.049 1.942-.986 3.744-2.597 5.298-1.977 1.91-4.97 3.443-8.58 4.392L28.168 65.955l21.937-3.73c1.633 1.678 2.539 3.586 2.488 5.595z"
    />
    <path
      fill="#fff"
      d="M49.993 73.115c-1.977 1.911-4.97 3.443-8.58 4.393-1.005.264-11.09 1.075-12.181 1.243l-1.067-12.796z"
    />
    <path
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.939}
      d="M50.105 62.224c1.633 1.677 2.538 3.586 2.487 5.594-.049 1.941-.986 3.744-2.597 5.298-1.977 1.91-4.97 3.443-8.58 4.392-1.005.265-2.06.485-3.152.653a36 36 0 0 1-6.393.396c-11.286-.288-20.307-5.562-20.15-11.779"
    />
    <defs>
      <linearGradient
        id="empty-data_svg__a"
        x1={13.18}
        x2={51.132}
        y1={61.325}
        y2={73.275}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.09} stopColor="#228FE6" />
        <stop offset={0.2} stopColor="#1AA0E0" />
        <stop offset={0.33} stopColor="#0DBBD6" />
        <stop offset={0.44} stopColor="#00DACB" />
        <stop offset={0.78} stopColor="#00DACB" stopOpacity={0.38} />
        <stop offset={1} stopColor="#00DACB" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgEmptyData;
